import FeedbackPage from "@components/FeedbackPage"

export default function AiFeature() {
  return (
    <FeedbackPage
      emoji="📸"
      titleKey="pages.onboarding.aiFeature.heading"
      textKey="pages.onboarding.aiFeature.info"
    />
  )
}
